var commentObj = {
  model: function () {

    // 阻止遮罩内元素冒泡
    $('.black_win_publish_com_con,.child_black_win_publish_com_con,.hot_black_win_publish_com_con').click(function () {
      event.stopPropagation();
    })

    //点击发送按钮取消弹层
    $(".fff").click(function () {
      $(".black_win_publish_comment").fadeOut(400);
      $(".child_black_win_publish_comment").fadeOut(400);
    });

    //关闭评论弹层
    $(".hot_black_win_publish_com_tit .hot_qx_com_btn,.hot_black_win_publish_comment").click(function () {
      $('body').css('overflow', 'scroll');
      $(".hot_black_win_publish_comment").fadeOut(400);
      removeUnScroll();
    });

    //紧张页面滚动
    var isDisScroll = false;

    //滚动条滚动  显示作者
    //del
    /*if (author) {
      $(window).scroll(function () {
        if (!isDisScroll) {
          var docH = parseFloat($(document).scrollTop());
          var art_authorFixedP=parseFloat($("#art_authorFixed").offset().top);
          if (docH >=art_authorFixedP) {
            $(".topbar .title").html("");
            $(".art_authorFixed").removeClass('hide');
            $(".art_author").css("display", "none");
          } else {
            $(".topbar .title").html("正文");
            $(".art_author").css("display", "block");
            $(".art_authorFixed").addClass('hide');
            $(".art_authorFixed").addClass('ani-to-top-author-box');
            $(".art_authorFixed").removeClass('ani-form-top-author-box');
          }
        }
      })
    }*/

    //点击底部客服按钮
    //del
    /*var article_flag = 0;
    $(".art_footer_tab_right .article-kefu").click(function () {
      if (!$.cookie('kefu_showed')) {
        var expire_time = new Date();
        expire_time.setHours(23);
        expire_time.setMinutes(59);
        expire_time.setSeconds(59);
        $.cookie('kefu_showed', true, {
          path: '/',
          expire: expire_time
        })
      }
      if (article_flag == 0) {
        $(".kefu-list-box").removeClass('hide');
        $(this).addClass("article-tab-col");
        $(this).siblings().removeClass("article-tab-col");
        $(this).parent().siblings().find("i").removeClass("article-tab-col");
        $(this).parent().siblings().find("svg").removeClass("article-tab-col");
        article_flag = 1;
      } else if (article_flag == 1) {
        $(".kefu-list-box").addClass('hide');
        $(this).removeClass("article-tab-col");
        article_flag = 0;
      }

    });*/

    //设置热门评论高度
    $('.hot_black_win_publish_com_detail').height(window.innerHeight * 0.7);
    $('.parent_huifu_cont_top_box_parent').css({'max-height': window.innerHeight * 0.5, 'overflow-y': 'auto'});
//del
/*    window.cateData.api.getItemCondition = 'detail/' + articleId;
    window.cateData.pageModule = 'detail';*/
    var uid = isLogin() ? isLogin().memberId : 0;

    function Detail() {
      var self = this;
      self.id = articleId;
      self.title = articleTitle;
      self.collected = ko.observable();
      self.negative = ko.observable();
      self.commentCount = ko.observable();
      self.collectCount = ko.observable();
      // 评论列表
      self.comments = ko.observableArray();
      // 查看全部评论列表
      self.showMoreComments = ko.observableArray();
      self.commentsPage = 1;
      // 待发布的评论
      self.comment = ko.observable();
      // 父级评论id
      self.parentCommentId = 0;
      self.parentUserId = 0;
      // 一级评论id
      self.topId = 0;
      // 父评论，用于绑定内容到弹窗
      self.parentComment = ko.observable();
      self.willDelComment = ko.observable({
        obj: null,
        parent: null,
        isComments: null,
        show: false
      });
      // 加载主评论的flag
      self.loadArticleComment = true;
      self.cancel = function () {
        $(".black_win_publish_comment").fadeOut(400);
        $(".child_black_win_publish_comment").fadeOut(400);
        $(".huifu_author").show();
        self.comment('');
        removeUnScroll();
      };
      self.cancelDel = function () {
        self.willDelComment({
          obj: null,
          parent: null,
          isComments: null,
          show: false
        })
      };

      //确认删除评论
      self.confirm = function () {
        pageLoading.show();
        var delComment = self.willDelComment();
        self.willDelComment({
          obj: null,
          parent: null,
          isComments: null,
          show: false
        });
        getJson('/comment/delete/' + delComment.obj.id + '/' + uid, function (res) {
          if (delComment.parent.comments) {
            if (delComment.isComments) {
              delComment.parent.comments.remove(delComment.obj);
            }
            delComment.parent.showMoreComments.remove(delComment.obj);
            delComment.parent.commentCount(delComment.parent.commentCount() - 1);
          } else {
            delComment.parent.comment_son.content.remove(delComment.obj);
            delComment.parent.commentcont(delComment.parent.commentcont() - 1);
          }
          pageLoading.close();
          userRecode({behaviorType: '删除评论', behaviorResult: delComment.obj.content});
        });
      };
      self.collect = function (title) {
        var usrInfo = isLogin();
        //判断是否登录
        if (!usrInfo) {
          //行为记录
          userRecode({behaviorType: '收藏', behaviorResult: '无'});
          common.gotoLogin();
          return;
        }
        post('/collect', {
          articleId: self.id,
          status: Number(!self.collected()),
          sess: usrInfo.session
        }, function () {
          //行为记录
          userRecode({
            behaviorType: self.collected() ? '取消收藏' : '收藏',
            behaviorResult: title
          });
          self.collected(!self.collected());
          self.collectCount(self.collected() ? self.collectCount() + 1 : self.collectCount() - 1)
          if(self.collected()){
            msg.toast('点赞并收藏成功');
          }else{
            msg.toast('点赞/收藏已取消');
          }

        });
      };
      self.getArticleComment = function () {
        if (self.commentCount() > self.comments().length && self.loadArticleComment) {
          self.loadArticleComment = false;
          // layer加载
          if (self.comments().length) pageLoading.show();
          getJson('/comment/list?from=wap&objectId=' + self.id + '&page=' + self.commentsPage, function (res) {
            while (res.content.length) {
              if (self.commentsPage > 1) {
                self.showMoreComments.push(new Comment(res.content.shift()))
              } else {
                self.comments.push(new Comment(res.content.shift()))
              }
            }
            pageLoading.close();
            self.commentsPage++;
            self.loadArticleComment = true;
          })
        }
      };
      self.getArticleStatus=function(){
        $.ajax({
          type: "POST",
          url: '/api/statInfo/get',
          data: {
            articleId:self.id
          },
          dataType: "json",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          success: function (data) {
            var status=data.content[0];
            self.commentCount(status.commentCount);
            self.collectCount(status.collectCount);
            self.collected(status.collect);
            self.negative(status.unlike);
            self.getArticleComment();
          }
        });
      };

      self.getcollectStatus = function(data) {
        self.collectCount(data.totle);
        self.collected(data.status);
      };
      // 踩文章
      self.dislike = function () {
        if (!isLogin()) {
          userRecode({behaviorType: '差评', behaviorResult: '无'});
          common.gotoLogin();
          return;
        }
        getJson('/unlike/' + self.id + '/' + Number(!self.negative()) + '/' + uid, function (res) {
          self.negative(!self.negative());
          userRecode({
            behaviorType: self.negative() ? '差评' : '取消差评',
            behaviorResult: self.title
          });
        })
      };
      // 点击回复
      self.reply = function (obj, topId, className) {
        if (!isLogin()) {
          userRecode({behaviorType: '评论', behaviorResult: '无'});
          common.gotoLogin();
          return;
        }
        $("." + className).fadeIn(200);
        if (obj.comments) {
          self.topId = 0
        } else {
          self.parentComment(obj);
          self.parentCommentId = obj.id;
          self.parentUserId = obj.userId;
          self.topId = topId;

          // 定位用id
          var positionId = obj.id;
          // 滚动对象
          var scrollBody = $(window);
          if ($(".hot_black_win_publish_comment").is(':visible')) {
            positionId = 'm_' + positionId;
            scrollBody = $('.hot_black_win_publish_com_detail');
            $('.comment_item_blank').show();
          }

          var viewHeight = $(window).height();
          var repHeight = $('.child_black_win_publish_com_con').outerHeight(true);
          var scrollTop = $(scrollBody).scrollTop();
          var bottomToPageBottom = viewHeight - $('#' + positionId)[0].getBoundingClientRect().bottom;

          var scroolFix = scrollTop - bottomToPageBottom + repHeight;

          $(scrollBody).scrollTop(scroolFix);
        }
        unScroll();
      };
      // 发送评论
      self.sendComment = function () {
        if (!self.comment()) {
          msg.toast('评论不能为空');
          return
        }
        var params = {
          objectId: self.id,
          objectName: self.title,
          content: utf16toEntities(self.comment()),
          topId: self.topId,
          parentCommentId: self.parentCommentId,
          parentUserId: self.parentUserId,
          uid: uid,
          firstClassId: firstClassId,
          twoClassId: twoClassId
        };
        post('/comment/save', params, function (res) {
          if (res.result === 0) {
            msg.toast(res.desc);
            userRecode({
              behaviorType: '评论',
              behaviorResult: self.comment()
            });
            self.comment('');
            $(".black_win_publish_comment").fadeOut(400);
            $(".child_black_win_publish_comment").fadeOut(400);
            removeUnScroll();
          }
          $(".huifu_author").show();
          self.parentCommentId = self.parentUserId = 0
        })
      };

      // 评论列表弹窗
      self.moreReply = function (obj) {
        unScroll();
        if (!self.showMoreComments().length) {
          self.showMoreComments(self.comments());
        }
        $('body').css('overflow', 'hidden');
        $(".hot_black_win_publish_comment").fadeIn(400);
        $(".hot_black_win_publish_com_detail").scrollTop(5);//控制滚动条下移
        if ($(".hot_black_win_publish_com_detail").scrollTop() < 1) {
          vm.getArticleComment();
        }

        //距离顶部的距离
        if ($('#m_' + obj.id).length > 0) {
          var top = 0;
          setTimeout(function () {
            top = $('#m_' + obj.id).offset().top;
            // console.log(top);
            $(".hot_black_win_publish_com_detail").animate({
                  scrollTop: top - $('.hot_black_win_publish_com_detail').offset().top
                }, 200
            );
          }, 500);
        }
      };
    }

    //禁止后方滚动条滚动
    var scrollTop = 0;

    function unScroll() {
      if (!isDisScroll) {
        scrollTop = document.scrollingElement.scrollTop;
        document.body.classList.add('article-scroll-fixed');
        document.body.style.top = -scrollTop + 'px';
        isDisScroll = true;
      }

    }

    //移除禁止后方滚动条滚动
    function removeUnScroll() {
      //隐藏热门评论弹窗中的底部空白
      $('.comment_item_blank').hide();
      //延时一下因为弹出窗有个延时
      setTimeout(function () {
        //热门评论是否隐藏
        var flag = $('.hot_black_win_publish_comment').css("display");

        if (flag !== 'block') {
          document.body.classList.remove('article-scroll-fixed');
          document.scrollingElement.scrollTop = scrollTop;
          isDisScroll = false;
        }
      }, 500);
    }

    function Comment(c) {
      var comment = this;
      comment.id = c.id;
      comment.content = entitiestoUtf16(c.content);
      comment.lastUpdateTime = c.lastUpdateTime;
      comment.parentInfo = c.parentInfo;
      comment.userId = c.userId;
      comment.userInfo = c.userInfo;
      comment.commentcont = ko.observable(c.commentcont);
      comment.totalPage = c.comment_son ? c.comment_son.totalPage : 0;
      comment.currentPage = ko.observable(2);
      comment.collect = ko.observable(c.collect);
      comment.negative = ko.observable(c.negative);
      comment.likeNum = ko.observable(c.likeNum);
      comment.showDel = ko.computed(function () {
        return Number(uid) === Number(comment.userId)
      });
      // 赞
      comment.praise = function (comment) {
        if (!isLogin()) {
          userRecode({behaviorType: '评论点赞', behaviorResult: '无'});
          common.gotoLogin();
          return;
        }
        getJson('/comment/like/' + comment.id + '/' + Number(!comment.collect()) + '/' + uid, function (res) {
          if (res.result === 0) {
            comment.collect(!comment.collect());
            comment.likeNum(comment.collect() ? comment.likeNum() + 1 : comment.likeNum() - 1)
          }
          userRecode({
            behaviorType: comment.collect() ? '评论点赞' : '取消评论点赞',
            behaviorResult: comment.content
          });
        })
        //如果是dis状态，点赞时取消dis
        if(comment.negative()){
          comment.dislike(comment);
        }
      };
      // 踩
      comment.dislike = function (comment) {
        if (!isLogin()) {
          userRecode({behaviorType: '评论差评', behaviorResult: '无'});
          common.gotoLogin();
          return;
        }
        getJson('/comment/unlike/' + comment.id + '/' + Number(!comment.negative()) + '/' + uid, function (res) {
          if (res.result === 0) comment.negative(!comment.negative());
          userRecode({
            behaviorType: comment.negative() ? '评论差评' : '取消评论差评',
            behaviorResult: comment.content
          });
        })

        //如果是赞状态，点赞时取消赞
        if(comment.collect()){
          comment.praise(comment);
        }
      };
      // 加载更多子评论
      comment.more = function (p) {
        if (p.currentPage() <= p.totalPage) {
          pageLoading.show();
          getJson('/comment/show/wap/' + p.id + '/uid/' + p.currentPage(), function (res) {
            while (res.content.length) {
              p.comment_son.content.push(new Comment(res.content.shift()))
            }
            p.currentPage(p.currentPage() + 1);
            pageLoading.close();
            if (p.currentPage() === p.totalPage) {
              msg.toast('没有更多回复了');
            }
          })
        }
      };
      // 删除评论
      comment.del = function (obj, parent, isComments) {
        vm.willDelComment({
          obj: obj,
          parent: parent,
          isComments: isComments,
          show: true
        })
        msg.dialog('删除该评论，是否确认操作？', vm.confirm, vm.cancelDel);
      };
      // 设置子评论
      comment.comment_son = c.comment_son ? {
        totalPage: c.comment_son.totalPage,
        count: c.comment_son.count,
        content: ko.observableArray(c.comment_son.content.map(function (v) {
          return new Comment(v);
        }))
      } : {
        totalPage: 0,
        count: 0,
        content: ko.observableArray([])
      };
    }

    var vm = new Detail();
    var vmmodel = vm;
    ko.applyBindings(vm);
    vm.getArticleStatus();

    //接受点赞
    window.addEventListener('message' ,function (e) {
      //接受点赞
      if(e.data.type === 'like'){
        vm.getcollectStatus(e.data);
      }

      //接受回复
      if(e.data.type === 'moreReply'){
        vm.moreReply(e.data);
      }
    });


    // 浏览量
    $.ajax({
      type: "GET",
      url: '/api/detail/browse/' + vm.id,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    });

    //del
    /*if (!$.cookie('kefu_showed')) {
      setTimeout(function () {
        $(".kefu-list-box").removeClass('hide');
        $('.article-kefu').addClass('article-tab-col');
        article_flag = 1
      }, 100)
    }*/

    function getJson(url, callback) {
      $.ajax({
        type: "GET",
        url: '/api/interaction' + url,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data) {
          callback(data);
        },
        error: function (data) {
          if (window.isDebug) {
            console.log(data);
          }
        }
      });
    }

    function post(url, params, callback) {
      if (isLogin()) {
        params.uid = isLogin().memberId;
      }
      $.ajax({
        type: "POST",
        url: '/api/interaction' + url,
        data: params,
        dataType: "json",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data) {
          callback(data);
        },
        error: function (data) {
          if (window.isDebug) {
            console.log(data);
          }
        }
      });
    }

    function utf16toEntities(str) {
      var patt = /[\ud800-\udbff][\udc00-\udfff]/g;
      // 检测utf16字符正则
      str = str.replace(patt, function (char) {
        var H, L, code;
        if (char.length === 2) {
          H = char.charCodeAt(0);
          // 取出高位
          L = char.charCodeAt(1);
          // 取出低位
          code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00;
          // 转换算法
          return "&#" + code + ";";
        } else {
          return char;
        }
      });
      return str;
    }

    function entitiestoUtf16(str) {
      // 检测出形如&#12345;形式的字符串
      var strObj = utf16toEntities(str);
      var patt = /&#\d+;/g;
      var H, L, code;
      var arr = strObj.match(patt) || [];
      for (var i = 0; i < arr.length; i++) {
        code = arr[i];
        code = code.replace('&#', '').replace(';', '');
        // 高位
        H = Math.floor((code - 0x10000) / 0x400) + 0xD800;
        // 低位
        L = (code - 0x10000) % 0x400 + 0xDC00;
        code = "&#" + code + ";";
        var s = String.fromCharCode(H, L);
        strObj.replace(code, s);
      }
      return strObj;
    }

    // 监听滚动加载评论
    $(".hot_black_win_publish_com_detail").scroll(function () {
      var divHight = $(".hot_black_win_publish_com_detail").height(),
          scrollHight = $(this)[0].scrollHeight,
          scrollTop = $(this)[0].scrollTop;
      if (scrollTop + divHight + 3 > scrollHight) {
        vm.getArticleComment();
      }
    });

    // 滑动关闭客服弹窗
    //del
    /*window.onscroll = function () {
      $('.kefu-list-box').addClass('hide');
      $(".art_footer_tab_right .article-kefu").removeClass('article-tab-col');
      if (article_flag) article_flag = 0;
    };*/
  },

  init: function () {
    this.model();
  }
};
if(document.querySelector('.component-commnet')){
  commentObj.init();
}
